import React from "react"

const Header = ({ children }) => <header id="topnav" style={{backgroundColor: 'white'}}>{children}</header>

export default Header
